//
//
//
//
//
//
import { AppGeoportal } from '@giscube/geoportal-ee';

require('@giscube/geoportal/dist/lib/giscube-geoportal.min.css');

require('@giscube/geoportal-ee/dist/lib/giscube-geoportal-ee.min.css');

export default {
  name: 'App',
  extends: AppGeoportal,
  data: function data() {
    return {};
  }
};